import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import NotFound from "../extras/NotFound";
import WithNavbar from "../extras/PrivateRouteWithNavbar"
import ProductsTable from '../tables/ProductsTable'
import CreateProduct from "../creation-forms/CreateProduct";
import ViewProduct from "../view-edit/ViewProduct";
import AddProductToSale from "../creation-forms/AddProductToSale";

export default function Products() {
    const match = useRouteMatch();
    return (
        <Switch>
            <WithNavbar exact path={match.path} component={ProductsTable} />
            <WithNavbar path={`${match.path}/create`} component={CreateProduct} />
            <WithNavbar path={`${match.path}/view_:id`} component={ViewProduct} />
            <WithNavbar path={`${match.path}/add-to-sale_:id`} component={AddProductToSale} />
            <Route path="*" component={NotFound} />
        </Switch>
    )
}